import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import JuriesContent from './JuriesContent'
export default class Juries extends Component {

   

    render() {
        return (
            <div class="wrapper">

                <Navbar />
                <Mainmenu />
                <JuriesContent />
                <Footer />

            </div>


        )
    }
}
